<template>
  <div>
    <div class="page-title">New Text Block</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Text Block"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.text-blocks.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Text Block",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.TextBlock.new();
      this.form = data;
    },
    async create() {
      await this.$api.TextBlock.create(this.form);
      this.$router.push("/widgets/text-blocks");
    },
  },
};
</script>

<style></style>
